<template>
  <div class="knowledge-faultediting">
    <div class="top-title">故障编辑</div>
    <Card dis-hover>
      <Row>
        <Col :span="9">
          <Row>
            <Col :span="12">
              <div class="trees">
                <div class="title">设备树筛选</div>
                <div class="one-tree">
                  <Input
                    v-model="treeForm.tenantName"
                    prefix="ios-search"
                    placeholder="搜索"
                  />
                  <Cstree
                    @poster="postevet"
                    v-if="treeLists"
                    :treeLists="treeLists"
                  />
                </div>
              </div>
            </Col>
            <Col :span="12">
              <div class="trees">
                <div class="title">设备树筛选</div>
                <div class="one-tree">
                  <Input
                    v-model="treeForm.tenantName"
                    prefix="ios-search"
                    placeholder="搜索"
                  />
                  <Cstree
                    @poster="postevet"
                    v-if="treeLists"
                    :treeLists="treeLists"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <div class="line"></div>
        <Col :span="14">
          <div class="col-rig">
            <div>
              <div class="rig-title">
                您正在
                <span>东沟及</span>
                故障下新增故障原因
              </div>

              <div style="margin-top: 16px">
                <Form label-position="top" :rules="rules" :model="formItem">
                  <Row :gutter="80">
                    <Col :span="12">
                      <FormItem label="设备类型" prop="tenantName">
                        <div class="from-item">盾构机</div>
                      </FormItem>
                    </Col>
                    <Col :span="12">
                      <FormItem label="润滑点应用">
                        <div class="from-item">齿轮箱</div>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row :gutter="80" class="from-top">
                    <Col :span="12">
                      <FormItem label="故障描述" prop="tenantName">
                        <Input
                          v-model="formItem.tenantName"
                          placeholder="Enter something..."
                        ></Input>
                      </FormItem>
                    </Col>
                    <Col :span="12">
                      <FormItem label="故障编码">
                        <Input
                          v-model="formItem.name1"
                          placeholder="Enter something..."
                        ></Input>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row :gutter="80" class="from-top">
                    <Col :span="12">
                      <FormItem label="故障类型" prop="tenantName">
                        <Select v-model="formItem.name1">
                          <Option
                            v-for="item in cityList"
                            :value="item.value"
                            :key="item.value"
                            >{{ item.label }}</Option
                          >
                        </Select>
                      </FormItem>
                    </Col>
                    <Col :span="12">
                      <FormItem label="关键字">
                        <div class="tag-items">
                          <div
                            class="tag-item"
                            v-for="(index, key) in treeForm.gj"
                            :key="key"
                          >
                            <div class="item-label">{{ index }}</div>
                            <div class="close" @click="itemremove(key)">
                              <Icon type="ios-close" size="15" />
                            </div>
                          </div>
                          <div class="tag-item" @click="addtagitem">
                            <div class="add">
                              <Icon type="md-add" size="20" />
                            </div>
                            <div class="item-label-btn">添加关键字</div>
                          </div>
                        </div>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row :gutter="80" class="from-top">
                    <Col :span="12">
                      <div>
                        <FormItem label="关联设备" prop="tenantName">
                          <Select v-model="formItem.name1">
                            <Option
                              v-for="item in cityList"
                              :value="item.value"
                              :key="item.value"
                              >{{ item.label }}</Option
                            >
                          </Select>
                        </FormItem>
                      </div>
                      <div>
                        <FormItem label="指标体现">
                          <Row>
                            <Col span="12" style="padding-right: 10px">
                              <Select v-model="formItem.name1" filterable>
                                <Option
                                  v-for="item in cityList"
                                  :value="item.value"
                                  :key="item.value"
                                  >{{ item.label }}</Option
                                >
                              </Select>
                            </Col>
                            <Col span="12">
                              <Select
                                v-model="formItem.name1"
                                filterable
                                multiple
                              >
                                <Option
                                  v-for="item in cityList"
                                  :value="item.value"
                                  :key="item.value"
                                  >{{ item.label }}</Option
                                >
                              </Select>
                            </Col>
                          </Row>
                        </FormItem>
                      </div>
                    </Col>
                    <Col :span="12">
                      <FormItem label="详细描述">
                        <Input
                          v-model="formItem.name1"
                          type="textarea"
                          :rows="5"
                          placeholder="Enter something..."
                        />
                      </FormItem>
                    </Col>
                  </Row>
                  <Row :gutter="80" class="from-top">
                    <Col :span="12">
                      <div>
                        <FormItem label="严重等级" prop="tenantName">
                          <Select v-model="formItem.name1">
                            <Option
                              v-for="item in cityList"
                              :value="item.value"
                              :key="item.value"
                              >{{ item.label }}</Option
                            >
                          </Select>
                        </FormItem>
                      </div>
                      <div>
                        <FormItem label="检查难易" prop="tenantName">
                          <Select v-model="formItem.name1">
                            <Option
                              v-for="item in cityList"
                              :value="item.value"
                              :key="item.value"
                              >{{ item.label }}</Option
                            >
                          </Select>
                        </FormItem>
                      </div>
                    </Col>
                    <Col :span="12">
                      <FormItem label="解决方法">
                        <Input
                          v-model="formItem.name1"
                          type="textarea"
                          :rows="5"
                          placeholder="Enter something..."
                        />
                      </FormItem>
                    </Col>
                  </Row>
                  <Row :gutter="80" class="from-top">
                    <Col :span="12">
                      <div>
                        <FormItem
                          label="上层故障的可能性（概率）"
                          prop="tenantName"
                        >
                          <Select v-model="formItem.name1">
                            <Option
                              v-for="item in cityList"
                              :value="item.value"
                              :key="item.value"
                              >{{ item.label }}</Option
                            >
                          </Select>
                        </FormItem>
                      </div>
                      <div>
                        <FormItem label="参考案例" prop="tenantName">
                          <Select v-model="formItem.name1">
                            <Option
                              v-for="item in cityList"
                              :value="item.value"
                              :key="item.value"
                              >{{ item.label }}</Option
                            >
                          </Select>
                        </FormItem>
                      </div>
                    </Col>
                    <Col :span="12">
                      <FormItem label="参考案例">
                        <Input
                          v-model="formItem.name1"
                          type="textarea"
                          :rows="5"
                          placeholder="Enter something..."
                        />
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col span="24">
                      <FormItem label="测试组件">
                     
                      </FormItem>
                    </Col>

                    <Col span="24">
                      <FormItem label="上传图片">
                        <div class="rhWrapUpload">
                          <div class="imgWrap">
                            <div class="imgs" v-if="treeForm.imagesFullPath">
                              <img :src="treeForm.imagesFullPath" alt="" />
                              <Icon type="md-close-circle" @click="delImg()" />
                            </div>
                            <div v-else>
                              <img
                                src="../../assets/images/upload.png"
                                style="
                                  cursor: pointer;
                                  width: 150px;
                                  height: 150px;
                                "
                              />
                              <input
                                @change="uploadFunc"
                                type="file"
                                name="file"
                                accept="image/*"
                                id="upFilePic"
                                class="up-files"
                              />
                            </div>
                            <!-- <div class="addImg" v-else>
                                        <Spin v-if="uploadLoading" style="margin:40px 65px"></Spin>    
                                        <Icon type="md-add" v-else />
                                        <label for="upFilePic" class="up_label">
                                           
                                        </label>
                                    </div> -->
                          </div>
                          <p class="tip"> 格式：JPG、PNG或JPEG；推荐尺寸：600*600像素；大小：5MB内</p>
                        </div>
                        <div class="percentWrap" v-if="imgPercent">
                          <p class="name">
                            <Icon type="ios-image-outline" /> {{ fileName }}
                          </p>
                          <Progress
                            :stroke-width="4"
                            :status="upStatus"
                            :percent="imgPercent"
                          />
                        </div>
                      </FormItem>
                    </Col>
                  </Row>
                </Form>
                <div class="drawer-footer">
                  <Button
                    type="primary"
                    @click="submitForm('formValidate')"
                    :loading="btnLoading"
                    >提交</Button
                  >
                  <Button style="margin-left: 8px">取消</Button>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  </div>
</template>

<script>
import api from "@/api";
import Cstree from "@/components/c-stree/index";

export default {
  name: "knowledge-faultediting",
  components: {

    Cstree,
  },

  data() {
    return {
      imgaaaa: "",
      gjvalue: "",
      btnLoading: false,
      treeForm: {
        tenantName: undefined,
        gj: [],
      },
      imgPercent: null,
      percentInterval: null,
      upStatus: "active",
      rules: {
        tenantName: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
      },
      cityList: [
        {
          value: "New York",
          label: "New York",
        },
        {
          value: "London",
          label: "London",
        },
        {
          value: "Sydney",
          label: "Sydney",
        },
        {
          value: "Ottawa",
          label: "Ottawa",
        },
        {
          value: "Paris",
          label: "Paris",
        },
        {
          value: "Canberra",
          label: "Canberra",
        },
      ],
      formItem: {},
      treeLists: [
        {
          name: "河南省",
          children: [
            {
              name: "信阳市",
              children: [
                {
                  name: "潢川县",
                  children: [],
                },
              ],
            },
            {
              name: "郑州市",
              children: [
                {
                  name: "新政市",
                  children: [],
                },
              ],
            },
          ],
        },
        {
          name: "浙江省",
          children: [
            {
              name: "杭州市",
              children: [
                {
                  name: "余杭区",
                  children: [],
                },
              ],
            },
            {
              name: "台州市",
              children: [
                {
                  name: "台州县",
                  children: [],
                },
              ],
            },
          ],
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.$store.state.spinShow = false;
  },
  methods: {
    submitForm() {},
    uploadFunc() {
        console.log("111","w chufa ")
      this.upStatus = "active";
      var myfile = document.getElementById("upFilePic").files[0];
      this.fileName = myfile.name;
      let fileSize = myfile.size;
      const allowedImageTypes = ["image/jpg", "image/png"];
      
      if (!allowedImageTypes.includes(myfile.type)) {
        this.$Message.info("文件格式错误，请上传JPG、PNG或者JPEG格式的图片文件");
      
        return;
      }
      // if(myfile) this.uploadLoading = true

      //限制图片5MB以内
      if (fileSize > 1024 * 1024 * 5)
        return this.$Message.info("上传图片不能大于5MB");

      var oMyForm = new FormData();
      oMyForm.append("file", myfile);
      this.loadPercent();
      api.asxUpFile("post", "/ocm-admin/file/upload", oMyForm).then((res) => {
        if (res.code === "00000") {
          this.treeForm.images = res.data.key;
          this.treeForm.imagesFullPath = res.data.url;
          this.$Message.success("上传成功");
        } else {
          this.upStatus = "wrong";
        }
        // this.uploadLoading = false
        // 清除percent定时
        window.clearInterval(this.percentInterval);
        this.imgPercent = 100;
      });
    },
    loadPercent() {
      this.imgPercent = 0;
      this.percentInterval = setInterval(() => {
        if (this.imgPercent > 95) {
          this.imgPercent = 99;
        } else if (this.imgPercent > 50) {
          this.imgPercent += 3;
        } else {
          this.imgPercent += 18;
        }
      }, 100);
    },
    itemremove(key) {
      this.treeForm.gj.splice(key, 1);
    },
    addtagitem() {
      this.$Modal.confirm({
        render: (h) => {
          let html = h("div", [
            h(
              "div",
              {
                style: {
                  color: "#000000",
                  fontSize: "20px",
                  fontWeight: "549",
                  marginBottom: "20px",
                },
              },
              "添加关键字"
            ),
            h("Input", {
              props: {
                value: this.value,
                autofocus: true,
                placeholder: "请添加关键字",
              },
              on: {
                input: (val) => {
                  if (val) {
                    this.gjvalue = val;
                  }
                },
              },
            }),
          ]);
          return html;
        },
        onOk: () => {
          if (this.gjvalue) {
            this.treeForm.gj.push(this.gjvalue);
          }
        },
      });
    },
    postevet() {
      this.treeLists = [
        {
          name: "河南省",
          children: [
            {
              name: "信阳市",
              children: [
                {
                  name: "潢川县",
                  children: [],
                },
              ],
            },
            {
              name: "郑州市",
              children: [
                {
                  name: "新政市",
                  children: [],
                },
              ],
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang='less'>
.knowledge-faultediting {
  .ivu-card-bordered {
    min-height: 80vh;
  }

  .ivu-card-body {
    height: 100%;

    .ivu-row {
      height: 100%;
    }
  }

  .trees {
    width: 241px;
  }

  .one-tree {
    width: 100%;

    .title {
      font-size: 12px;

      font-weight: normal;
      color: #555555;
    }
  }

  .one-tree {
    .ivu-input-wrapper {
      .ivu-input {
        border: none;
        border-bottom: 1px solid #dcdee2;
        border-radius: 0;
        box-shadow: none !important;
      }
    }
  }

  .tag-items {
    display: flex;
    align-items: center;

    .tag-item {
      padding: 0 9px 0 12px;
      height: 32px;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      border: 1px solid #dedede;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;

      .item-label-btn {
        color: rgba(136, 136, 136, 1);
      }

      .item-label {
        font-size: 12px;

        font-weight: normal;
        color: #000000;
        line-height: 20px;
      }

      .add {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #e0e0e0;
        margin-right: 4px;
      }

      .close {
        background: #d0d0d0;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #fff;
        margin-left: 4px;
      }
    }
  }

  .rhWrapUpload {
    .imgWrap {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;

      .imgs {
        position: relative;
        width: 150px;
        height: 150px;
        text-align: center;
        // border: 1px solid #f2f2f2;
        overflow: hidden;

        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }

        .ivu-icon {
          position: absolute;
          font-size: 24px;
          z-index: 2;
          top: 0px;
          right: 0px;
          cursor: pointer;
        }
      }

      .addImg {
        position: relative;
        width: 150px;
        height: 150px;
        text-align: center;
        border: 1px dashed #dcdee2;
        cursor: pointer;

        .ivu-icon {
          color: #dcdee2;
          font-size: 30px;
          margin-top: 30px;
        }

        .up_label {
          width: 150px;
          height: 150px;
          cursor: pointer;

          input {
            width: 1%;
            height: 1%;
            font-size: 0;
          }
        }
      }
    }

    .tip {
      padding: 10px 0;
      color: #aaa;
    }
  }
}

.line {
  width: 0px;
  height: 100%;
  opacity: 1;
  border: 1px solid rgba(0, 0, 0, 0.10196078431372549);
}

.col-rig {
  margin-left: 69px;

  .rig-title {
    font-size: 12px;

    font-weight: normal;
    color: #555555;

    span {
      color: rgba(12, 71, 157, 1);
    }
  }

  .from-top {
    position: relative;
    top: -8px;
  }

  .from-item {
    font-size: 12px;

    font-weight: 400;
    color: #000000;
  }
}

.up-files {
  position: absolute;
  left: 0;
  opacity: 0;
  width: 150px;
  height: 150px;
  font-size: 0;
  cursor: pointer;
}
</style>